// CC: extracted from integrations.component.ts -> LDAP section
import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {GeneralService} from '../../../../../services/generalService';
import {DICTIONARY} from '../../../../../dictionary';
import {RouteService} from '../../../../../services/routeService';
import {NotificationService} from '../../../../../services/notificationService';

@Component({
	selector: 'ldap-integration-component',
	templateUrl: './ldap-integration.component.html',
})
export class LdapIntegrationComponent implements OnInit {
	@Output() connectionChanged = new EventEmitter<void>();
	dic = DICTIONARY;
	planInfo: any;
	integrationActionInProcess = false;
	integImportGroupsSummary = false;
	showGroups = false;
	showAliases = false;
	ldapConnectPopup: any;
	showPassword: boolean;

	constructor(public gs: GeneralService,
				private rs: RouteService, private ns: NotificationService) {}

	ngOnInit() {
		this.getIntegrations();
	}

	// CC: taken from integrations.component.ts -> getIntegrations (LDAP-specific parts)
	getIntegrations = () => {
		this.rs.getIntegrations().then((planInfo) => {
			this.planInfo = planInfo;
			this.planInfo.integrations = this.planInfo.integrations || {};
		});
	}

	isConnected = () => {
		return !!this.planInfo?.integrations.ldap?.enabled;
	}

	// CC: taken from integrations.component.ts -> connectToLdap
	connectToLdap = () => {
		if (this.isConnected()) {
			this.gs.showPopup({
				title: 'Disconnect from LDAP',
				subTitle: `Please note - you are about to cancel the connection to your LDAP`,
				body: ["Groups will not be automatically updated"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					this.rs.disconnectLDAP().then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from LDAP server');
						this.planInfo.integrations.ldap = {
							enabled: false
						};
						this.connectionChanged.emit();
					}, () => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.ldapConnectPopup = {
				ldapUsername: '',
				ldapPassword: '',
				ldapEndpoint: '',
				ldapBaseDN: '',
				ldapSecure: true,
				ldapPort: 636,
				show: true
			};
		}
	}

	// CC: taken from integrations.component.ts -> connectLdapExecute
	connectLdapExecute = () => {
		if (!this.ldapConnectPopup.ldapUsername || !this.ldapConnectPopup.ldapPassword || !this.ldapConnectPopup.ldapEndpoint) {
			return;
		}

		this.integrationActionInProcess = true;

		const endpoint = `ldap${this.ldapConnectPopup.ldapSecure ? 's' : ''}://${this.ldapConnectPopup.ldapEndpoint}:${this.ldapConnectPopup.ldapPort}`;

		const ldapInfo = {
			username: this.ldapConnectPopup.ldapUsername,
			password: this.ldapConnectPopup.ldapPassword,
			endpoint: endpoint,
			baseDN: this.ldapConnectPopup.ldapBaseDN,
		};
		this.rs.connectLDAP(ldapInfo).then(() => {
			this.ldapConnectPopup = null;
			this.ns.showInfoMessage('Successfully connected to LDAP');
			this.planInfo.integrations.ldap = ldapInfo;
			this.planInfo.integrations.ldap.enabled = true;
			this.integrationActionInProcess = false;
			this.connectionChanged.emit();
		}, (err) => {
			if (err?.data?.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	}

	// CC: taken from integrations.component.ts -> integImportGroups (LDAP case)
	integImportGroups = () => {
		if (!this.isConnected()) {
			return;
		}

		this.integrationActionInProcess = true;
		this.rs.createLdapGroups().then(() => {
			this.ns.showInfoMessage('We are updating information from your mail server, this process may take several minutes to finish');
			this.integrationActionInProcess = false;
			this.integImportGroupsSummary = true;
		}, () => {
			this.integrationActionInProcess = false;
		});
	}

	getGroups = (show) => {
		this.showGroups = show;
	}

	getMailboxesAliases = (show) => {
		this.showAliases = show;
	}
}
